import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Instagram, Smartphone, Map } from "lucide-react";
import { ShareModal } from "./ShareModal";
import { OPEN_CONSENT_EVENT } from "@/lib/consent";

export function Footer() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language?.split("-")[0] || "pt";

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm mt-auto relative z-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-3 text-xs sm:text-sm">
          <button 
            onClick={() => handleNavigation("/apresentacao")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("footer.about")}
          </button>
          <button 
            onClick={() => handleNavigation("/planos")}
            className="text-muted-foreground hover:text-foreground transition-colors"
            data-testid="footer-pricing-link"
          >
            {t("footer.plans")}
          </button>
          <button 
            onClick={() => handleNavigation("/ajuda")}
            className="text-muted-foreground hover:text-foreground transition-colors"
            data-testid="footer-help-center-link"
          >
            {t("footer.help_center")}
          </button>
          <button 
            onClick={() => handleNavigation("/motoblogs")}
            className="text-muted-foreground hover:text-foreground transition-colors"
            data-testid="footer-blog-link"
          >
            Moto Blogs
          </button>
          <button 
            onClick={() => handleNavigation("/privacidade")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("footer.privacy")}
          </button>
          <button 
            onClick={() => handleNavigation("/termos")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("footer.terms")}
          </button>
          <button 
            onClick={() => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))}
            className="text-muted-foreground hover:text-foreground transition-colors"
            data-testid="footer-cookies-link"
          >
            Cookies
          </button>
          <button 
            onClick={() => handleNavigation("/contactos")}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("footer.contact")}
          </button>
          <button
            onClick={() => handleNavigation("/ferramentas/editor")}
            className="inline-flex items-center gap-1.5 text-orange-500 hover:text-orange-400 transition-colors"
            data-testid="footer-tools-link"
          >
            <Map className="h-3.5 w-3.5" />
            {t("footer.tools")}
          </button>
          {currentLang === "pt" && (
            <button
              onClick={() => handleNavigation("/go")}
              className="inline-flex items-center gap-1.5 text-orange-500 hover:text-orange-400 transition-colors"
              data-testid="footer-go-link"
            >
              <Smartphone className="h-3.5 w-3.5" />
              Go (beta)
            </button>
          )}
        </div>
        
        {/* Logo, Share and copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 pt-3 border-t border-border">
          <div className="flex items-center gap-1 text-muted-foreground">
            <span className="text-xs">©MotoTrips · www.mototrips.net</span>
          </div>
          
          {/* Instagram + Share Site Button */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/mototrips.insta/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" />
              Instagram
            </a>
            <ShareModal 
              type="site" 
              variant="ghost" 
              size="sm"
              className="text-muted-foreground hover:text-foreground h-7"
            />
          </div>
          
          <div className="text-xs text-muted-foreground">
            {t("footer.slogan")}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
